import React from 'react';
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import * as S from './styles';
//assets
import cal from "img/date-calendar-white-viveo.svg";
import Text from 'components/Text';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

interface IDasbhboard {
    setDateFilterON: any,
}

const DateDashboard = ({ setDateFilterON }: IDasbhboard) => {
    const dateFilter = useSelector((stateFilter: RootState) => stateFilter.quotesDashboard);
    const dispatch = useDispatch();

    const dayOfWeek = `(${format(new Date(), "iiii", { locale: ptBR })})`;
    const day = `${format(new Date(), "dd/MM/yyyy ", { locale: ptBR })} ${dayOfWeek}`;

    const handleCleanFilter = () => {
        setDateFilterON(false);
        dispatch({
            type: 'SET_DATES',
            startDate: undefined,
            endDate: undefined,
            filterON: false
        });
    };

    return (
        <S.DateDashboard>
            {
                (dateFilter?.filterON && dateFilter?.startDate && dateFilter?.endDate)
                    ? (
                        <S.DateContent>
                            <img src={cal} alt="Calendario" className="mr-2" />
                            <p onClick={() => setDateFilterON(true)} className="mr-2">{`${format(dateFilter?.startDate, "dd/MM/yyyy", { locale: ptBR })}  -  ${format(dateFilter?.endDate, "dd/MM/yyyy", { locale: ptBR })} `}</p>
                            <span onClick={() => handleCleanFilter()}>Limpar</span>
                        </S.DateContent>
                    )
                    : (
                        <S.DateContent onClick={() => setDateFilterON(true)}>
                            <img src={cal} alt="Calendario" className="mr-2" />
                            <Text>{day}</Text>
                        </S.DateContent>
                    )
            }
        </S.DateDashboard >
    );
};

export default DateDashboard;